import React, { Component } from 'react'
import { connect } from 'react-redux'
import SiteVars from '~/Classes/siteVars'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import i18n from '~/i18n'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import moment from 'moment'
import AiBadge from '~/Common-Objects/Icons/AiBadge'

@connect((store) => {
    return { user: store.user, accountMaster: store.accountMaster, permissionStore: store.permission }
})
class ThemePanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            screenshotUrl: '',
            templateImageLoaded: false,
            error: false
        }
        this.checkTemplateImageExists = this.checkTemplateImageExists.bind(this)
        this.initialise = this.initialise.bind(this)
    }

    componentWillUnmount() {
        this.unmounting = true
        if (this.imageCheckTimer) {
            clearTimeout(this.imageCheckTimer)
            this.imageCheckTimer = null
        }
    }

    componentDidMount() {
        this.initialise()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.theme.id != this.props.theme.id) this.initialise()
    }

    initialise() {
        let url = ''

        const accountMaster = this.props.accountMaster && this.props.accountMaster.accountMaster
        const accountId = accountMaster ? accountMaster.id : ''

        const lastUpdated =
            accountMaster && accountMaster.options.brandAnalyzer
                ? accountMaster.options.brandAnalyzer.lastUpdated
                : null
        const hasBrandAnalyzerUpdate = lastUpdated !== null && lastUpdated !== undefined

        const isBrandedTheme = this.props.theme.brandAnalyzer

        const isBasicThemeType = [0, 1, 2, 10].includes(this.props.theme.type)

        if (isBasicThemeType && (!isBrandedTheme || !hasBrandAnalyzerUpdate)) {
            url = SiteVars.repoEndPoint + 'siteContent/themes/theme' + this.props.theme.id + '.jpg'
        } else if (isBrandedTheme && hasBrandAnalyzerUpdate) {
            url =
                SiteVars.repoEndPoint +
                'userContent/' +
                accountId +
                '/templates/screenshots/' +
                this.props.theme.id +
                '' +
                new Date(lastUpdated).getTime() +
                '.jpg'
        } else {
            url =
                SiteVars.repoEndPoint +
                'userContent/' +
                accountId +
                '/templates/screenshots/template' +
                this.props.theme.id +
                '.jpg'
        }

        if (this.imageCheckTimer) {
            clearTimeout(this.imageCheckTimer)
            this.imageCheckTimer = null
        }

        this.setState({ screenshotUrl: url, templateImageLoaded: false, error: false }, () => {
            this.imageCheckStartTime = Date.now()
            if (url) {
                this.checkTemplateImageExists()
            }
        })
    }

    checkTemplateImageExists() {
        if (this.unmounting) return
        if (this.state.templateImageLoaded) return

        const MAX_MS = 15000
        const RETRY_MS = 500

        const now = Date.now()
        if (!this.imageCheckStartTime) this.imageCheckStartTime = now

        if (now - this.imageCheckStartTime > MAX_MS) {
            if (this.imageCheckTimer) {
                clearTimeout(this.imageCheckTimer)
                this.imageCheckTimer = null
            }
            this.setState({ error: true })
            return
        }

        const img = new Image()
        img.onload = () => {
            if (this.unmounting) return
            if (this.imageCheckTimer) {
                clearTimeout(this.imageCheckTimer)
                this.imageCheckTimer = null
            }
            this.setState({ templateImageLoaded: true, error: false })
        }
        img.onerror = () => {
            if (this.unmounting) return
            this.setState({ error: true })
            this.imageCheckTimer = setTimeout(this.checkTemplateImageExists, RETRY_MS)
        }
        img.src = this.state.screenshotUrl
    }

    render() {
        const isBasicThemeType = [0, 1, 2, 10].includes(this.props.theme.type)
        if (isBasicThemeType) {
            var classes = 'template-themeselector-theme'
            if (this.props.selected) {
                classes += ' template-themeselector-theme-selected'
            }

            var screenshotUrl = this.state.screenshotUrl

            var style = {}
            if (this.props.style) {
                style = this.props.style
            }

            var isNew = false
            if (this.props.theme.createdAt) {
                var timeDiff = moment().diff(moment(this.props.theme.createdAt), 'days')
                if (timeDiff < 30) isNew = true
            }

            let isBrandAnalyzer = false
            if (this.props.theme.brandAnalyzer) {
                isBrandAnalyzer = true
            }
            let doPreview = true
            if (this.props.theme.type === 0) doPreview = false
            if (this.props.disablePreview) doPreview = false

            return (
                <Paper className={classes} onClick={this.props.select} style={style}>
                    {isNew && <div className='template-themeselected-theme-new'>New</div>}
                    {doPreview && (
                        <div className='template-themeselected-theme-toolBar' onClick={this.props.preview}>
                            <Icons icon='magnifier' style={{ width: '20px', height: '20px' }} />
                        </div>
                    )}

                    <div className='template-themeselected-theme-image'>
                        {this.state.templateImageLoaded ? (
                            <img
                                src={screenshotUrl}
                                alt={this.props.theme.name}
                                style={{ width: '100%', height: 'auto' }}
                            />
                        ) : (
                            <LoadingIcons iconType='2' />
                        )}
                    </div>

                    <div className='template-themeselected-theme-bottomholder'>
                        <div className='template-themeselected-theme-title'>{this.props.theme.name}</div>
                        {isBrandAnalyzer && <AiBadge />}
                    </div>
                </Paper>
            )
        } else {
            var classes = 'template-themeselector-theme'
            if (this.props.selected) {
                classes += ' template-themeselector-theme-selected'
            }

            var screenshotUrl = this.state.screenshotUrl
            var dateAdded = this.props.theme.createdAt ? this.props.theme.createdAt : this.props.theme.dateAdded
            return (
                <Paper className={classes} onClick={this.props.select}>
                    <div
                        className={
                            (this.props.className ? this.props.className : '') + ' template-themeselected-theme-image'
                        }
                        style={{ backgroundImage: screenshotUrl ? 'url(' + screenshotUrl + ')' : '' }}
                    >
                        {this.state.error && (
                            <div style={{ height: 250 }}>
                                {' '}
                                <LoadingIcons iconType='2' />
                            </div>
                        )}
                    </div>
                    <div className='template-themeselected-theme-bottomholder'>
                        <div className='template-themeselected-theme-title'>
                            {this.props.theme.templateName || this.props.theme.name}
                        </div>
                        <div className='template-themeselected-theme-date'>
                            {i18n.t('templates:add.created')}: {DateTimeFunctions.formatDateTime(dateAdded, 2)}
                        </div>
                    </div>
                </Paper>
            )
        }
    }
}

export default ThemePanel
